import tw from "twin.macro";

export const Cardv2GridSection = tw.section`w-full px-[9.875rem] pb-[9.875rem] columns-2 gap-[4.875rem] space-y-[4.875rem]`